import { Endpoint } from '../endpoint';
import {
  UserCourseStepResponse,
  UserCourseId,
  UserCourseResponse,
  UserCourseStepId,
  CourseStepAnswers,
  CourseStepProgressResponse,
  CourseSessionId,
} from '@business/entities/user_course';
import { CourseId } from '@business/entities/course';
import { CompactUserResponse, UserId } from '@business/entities/account';
import { R } from '@core/utils/r';
import { CommonService } from '@business/services';
import { TenantId } from '@business/entities/tenant';

export function fetchCourse(id: UserCourseId, tenantId?: TenantId) {
  const params = R.objectCompact({ tenantId });
  return Endpoint.get<UserCourseResponse>(`@gc/user-courses/course/${id}`, { params });
}

export function fetchUserCourseVersions(courseId: CourseId, userId?: UserId, tenantId?: TenantId) {
  const params = R.objectCompact({ courseId, userId, tenantId });
  return Endpoint.get<UserCourseResponse[]>(`@gc/user-courses/user-course-versions`, { params });
}

export function stepComplete(id: UserCourseId, stepId: UserCourseStepId, answers: CourseStepAnswers) {
  return Endpoint.post<UserCourseStepResponse>(`@gc/user-courses/mark-complete/${id}/${stepId}`, { data: { answers } });
}

export function onProgress(stepId: string, progress: CourseStepAnswers) {
  return Endpoint.post<CourseStepProgressResponse>(`@gc/user-courses/user-progress/${stepId}`, { data: { progress } });
}

export function submitEssay(stepId: string, progress: CourseStepAnswers) {
  // const formData = CommonService.toFormData(progress);
  return Endpoint.post<CourseStepProgressResponse>(`@gc/user-courses/user-essay/${stepId}`, { data: progress });
}

export function submitUploadDrill(stepId: string, progress: CourseStepAnswers) {
  // const formData = CommonService.toFormData(progress);
  return Endpoint.post<CourseStepProgressResponse>(`@gc/user-courses/user-upload/${stepId}`, { data: progress });
}

export function fetchCourseSessionId() {
  return Endpoint.get<CourseSessionId>(`@gc/user-courses/course-session-id`);
}

export function createStepTracker(stepId: UserCourseStepId, sessionId: CourseSessionId, time: number) {
  return Endpoint.post<void>(`@gc/user-courses/step-tracker`, { data: { stepId, sessionId, time } });
}

export function fetchAssignedCourseUsers() {
  return Endpoint.get<CompactUserResponse>(`@gc/user-courses/users`);
}
